<template>
  <dl class="definition-list cf">
    <template v-for="({ key, value }, idx) in keysValues">
      <dt class="definition-list__label" :key="idx + key">{{ $te(key) ? $t(key) : key }}</dt>
      <dd class="definition-list__value" :key="idx + value">{{ $te(value) ? $t(value) : value }}</dd>
    </template>
  </dl>
</template>

<script>
export default {
  props: {
    keysValues: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.definition-list {
  font-size: 1.3rem;
  // @supports (display: grid) {
  //   display: grid;
  //   grid-template-columns: min-content 1fr;
  // }
  &__label, &__value {
    display: block;
    float: left;
    margin-bottom: 1.5rem;
  }
  &__label {
    font-family: $ff-gotham-700;
    font-weight: normal;
    text-transform: uppercase;
    color: $c-text-black;
    clear: left;
    &:after {
      content: ': ';
      margin-right: 0.7rem;
    }
  }
  &__value {
    font-family: $ff-gotham-300;
    font-weight: normal;
    color: $c-text-paragraph;
    margin: 0;
  }
}
</style>
